import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-evaluation-history-modal',
  templateUrl: './evaluation-history-modal.component.html',
  styleUrls: ['./evaluation-history-modal.component.scss']
})
export class EvaluationHistoryModalComponent implements OnInit {

  historyItems = []

  constructor() { }

  ngOnInit(): void {
  }

}
